/**
 * CreateWorkspaceModal Messages
 *
 * This contains all the text for the CreateWorkspaceModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.createWorkspaceModal';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  nameFeedback: {
    id: `${scope}.nameFeedback`,
    defaultMessage: 'Name cannot be empty',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  createWorkspace: {
    id: `${scope}.createWorkspace`,
    defaultMessage: 'create workspace',
  },
});
